<template>
    <div class="minbestand">
        <router-view></router-view>
        <div class="minbestandHolder">
            <div class="minbestandtop">
                <button class="downloadButton" @click="downloadList()">download</button>
            </div>

            <div class="minbestandListe">
                <table class="minbestandTable">
                    <tr>
                        <th>art nummer</th>
                        <th>min</th>
                        <th>bestand</th>
                        <th>bestellt</th>
                    </tr>
                    <tr class="minbestandListeElement"
                        v-for="item in minArt"
                        :key="item.id"
                        @click="gotoArt(item.id)"
                    >
                        <td class="listelElement">{{item.artnum}}</td>
                        <td class="listelElement">{{item.besMin}}</td>
                        <td class="listelElement">{{item.besMax}}</td>
                        <td class="listelElement">{{item.bestell}}</td>

                    </tr>
                </table>
            </div>
        </div>

    </div>
</template>

<script>
import http from '../../http/http';

export default {
    components: {},
    data() {
        return {}
    },
    props: {
        stao: {
            type: String,
            default: '1'
        }
    },
    computed: {
        minArt() {
            return this.$store.getters['lager/minbestand'];
        },
        apiurl() {
            return http.defaults.baseURL;
        }

    },
    watch: {},
    methods: {
        downloadList() {
            this.$store.dispatch('lager/downloadMinBestand', { stao: this.stao, url: this.apiurl });
        },

        gotoArt(id) {
            const url = '/fotodatenbank/editart/' + id + '/' + this.stao;
            this.$router.push(url);
        }

    },
    beforeDestroy() {
    },
    created() {
        this.$store.dispatch('lager/minbestand', { stao: this.stao });
    }
}
</script>

<style scoped lang="scss">

    .minbestand {
        position: absolute;
        width: 100%;
        height: 100vh;
        top: 0;
        left: 0;
        /*overflow-y: scroll;*/
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: $color-white;
    }

    .minbestandHolder {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100vh;
        /* overflow-y: scroll; */
    }

    .minbestandListe {
        width: 100%;
        overflow-y: scroll;
    }

    .minbestandTable {
        width: 100%;
        padding: 0.375rem;
    }

    .minbestandtop {
        position: relative;
        height: 70px;
    }

    .minbestandListeElement {
        font-size: 1.5rem;
        cursor: pointer;
    }

    .minbestandListeElement:hover {
        background-color: $color-gray;
    }

    .minbestandListeElement:active {
        background-color: $color-green;
    }

    .listelElement {
        text-align: center;
        vertical-align: middle;
    }

    .downloadButton {
        position: absolute;
        right: 0.375rem;
        top: 0.375rem;
        font-size: 1.25rem;

    }

    @include medium {

        .minbestandHolder {
            width: 31rem;
            @include default-shadow;
        }

    }

    @include extra-large {

        .minbestandHolder {
            width: 31rem;
            @include default-shadow;
            height: 80vh;
        }
    }

</style>
